import { useNavigate } from "react-router-dom"
import { rootPath } from "~/common/paths"

export const RETURN_TO_STORAGE_KEY = "returnTo"

const isSafeReturnPath = (path: string | null): path is string => {
  if (!path) return false
  // Must be a relative path on this origin. Reject protocol-relative,
  // absolute URLs, and anything that could escape the app.
  return path.startsWith("/") && !path.startsWith("//")
}

export const useNavigateAfterAuth = () => {
  const navigate = useNavigate()

  const navigateAfterAuth = () => {
    const returnTo = localStorage.getItem(RETURN_TO_STORAGE_KEY)
    localStorage.removeItem(RETURN_TO_STORAGE_KEY)
    if (isSafeReturnPath(returnTo)) {
      navigate(returnTo)
    } else {
      navigate(rootPath({}))
    }
  }

  return { navigateAfterAuth }
}
